export enum NotificationStatus {
  active = 'active',
  inactive = 'inactive',
}
